module.exports = __webpack_public_path__ + "static/media/icon-manage-class-student-list-plan-premium.015a200a.svg";